/**
 * 受講者の担当キャリアコンサル設定（admin/user-group/consultant-assignments）の担当キャリアコンサル入力欄
 *
 * 講師の入力欄（lecturer_user_select.js）と同じく、input[list] に名前を入力して候補（#career_consultants_list）から選ぶと、
 * 同じ .js-consultant-assignment-field 内の hidden（.js-consultant-assignment-id）にキャリコンのIDを入れる。
 * - 空欄: 未割り当て（hidden は空）
 * - 候補にない名前: hidden は空にし、入力欄を赤枠にしてメッセージを出す。「登録」を押しても送信せず、最初の該当欄に移る
 * - 候補にない名前が無ければ、確認ダイアログ（登録しますか？）を出してから送信する
 */
const INVALID_CLASSES = ['border-red-500', 'ring-2', 'ring-red-500', 'bg-red-50']

/**
 * 候補の表示名 => キャリコンのID
 *
 * @param {HTMLDataListElement} datalist
 * @returns {Map<string, string>}
 */
const build_label_to_id = (datalist) => {
    const label_to_id = new Map()
    datalist.querySelectorAll('option').forEach((option) => {
        if (option.value && option.dataset.id) label_to_id.set(option.value, option.dataset.id)
    })
    return label_to_id
}

/**
 * 入力欄の値から hidden のIDを決め、候補にない名前なら赤枠とメッセージを出す
 *
 * @param {HTMLInputElement} input
 * @param {Map<string, string>} label_to_id
 * @returns {boolean} 正しい値（空欄または候補の名前）か
 */
const sync_field = (input, label_to_id) => {
    const field = input.closest('.js-consultant-assignment-field')
    if (field === null) return true
    const hidden = field.querySelector('.js-consultant-assignment-id')
    const error = field.querySelector('.js-consultant-assignment-error')

    const value = input.value.trim()
    const id = label_to_id.get(value)
    const is_valid = value === '' || id !== undefined

    if (hidden !== null) hidden.value = is_valid && value !== '' ? id : ''
    INVALID_CLASSES.forEach((css_class) => input.classList.toggle(css_class, !is_valid))
    input.setAttribute('aria-invalid', is_valid ? 'false' : 'true')
    if (error !== null) error.classList.toggle('hidden', is_valid)

    return is_valid
}

const init_career_consultant_assignment_select = () => {
    const form = document.querySelector('[data-consultant-assignment-form]')
    const datalist = document.getElementById('career_consultants_list')
    if (form === null || datalist === null) return

    const label_to_id = build_label_to_id(datalist)
    const inputs = Array.from(form.querySelectorAll('.js-consultant-assignment-input'))

    inputs.forEach((input) => {
        input.addEventListener('input', () => sync_field(input, label_to_id))
        input.addEventListener('change', () => sync_field(input, label_to_id))
    })

    form.addEventListener('submit', (event) => {
        const invalid_inputs = inputs.filter((input) => !sync_field(input, label_to_id))
        if (invalid_inputs.length > 0) {
            event.preventDefault()
            invalid_inputs[0].focus()
            return
        }
        if (!window.confirm('登録しますか？')) event.preventDefault()
    })
}

document.addEventListener('DOMContentLoaded', init_career_consultant_assignment_select)
